import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { HttpRequestQueueService } from './request-queue.service';
import { environment } from '../../../environments/environment';

const apiBase = environment.api.replace(/\/+$/, '');

function isApiRequest(url: string): boolean {
  return url === apiBase || url.startsWith(apiBase + '/');
}

/**
 * Limits concurrent HTTP requests to the configured maximum (default 10).
 * Only API requests are queued; static asset requests bypass the limiter
 * so they are never blocked by slow or stalled API calls.
 */
export const requestQueueInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isApiRequest(req.url)) {
    return next(req);
  }
  const limiter = inject(HttpRequestQueueService);
  return limiter.run(() => next(req));
};
